export default __webpack_public_path__ + "static/100--stacked-area-6f20e70a2dd09e84894dca8265b5ef7b.png";